import QS from 'query-string';

import { apiFetcher } from '~/apis/api-fetcher';

import { AddFavoriteBody, EmptyResponse } from './models';

export type AddFavoriteParams = AddFavoriteBody & {
  pid: number;
};

/** 상품 찜하기 */
export const addFavorite = ({ pid, ...body }: AddFavoriteParams, requestInit?: RequestInit) =>
  apiFetcher.put<EmptyResponse>(`/api/pms/v1/favorite-products/${pid}`, body, requestInit);

export type RemoveFavoritesParams = {
  pids: Array<number>;
};

/** 상품 찜 해제 */
export const removeFavorites = ({ pids }: RemoveFavoritesParams, requestInit?: RequestInit) =>
  apiFetcher.delete<EmptyResponse>(`/api/pms/v1/favorite-products?${QS.stringify({ pids })}`, requestInit);
